import { render, staticRenderFns } from "./Corona.vue?vue&type=template&id=5669994b&scoped=true&"
import script from "./Corona.vue?vue&type=script&lang=js&"
export * from "./Corona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5669994b",
  null
  
)

export default component.exports